import axios from "axios";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
import { TaskDetailsV3_1 } from "../Types";
import { taskUrl } from "./urls";
export default async function getTaskV3_1(taskId, config) {
    const { data } = await axios.get(taskUrl("v3_1", taskId), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Advisor: config.advisorId,
        },
    });
    const decoded = TaskDetailsV3_1.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "[getTaskV3_1] returned unexpected data.";
        errorLog(getTaskV3_1.name, JSON.stringify(decoded.error.issues));
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getTask.v3_1.js.map